import React, {
    useState,
} from 'react';
import {
    Backdrop,
    CircularProgress,
} from '@material-ui/core';

export type Loading = {
    isLoading: boolean,
    setIsLoading: (isLoading: boolean) => void,
};

export const LoadingContext: React.Context<Loading> = React.createContext({
    isLoading: false,
    setIsLoading: () => {},
} as Loading);

interface LoadingProviderProps {
    children: React.ReactNode,
}

export function LoadingProvider(props: LoadingProviderProps): React.ReactElement {
    const {
        children,
    } = props;

    const [isLoading, setIsLoading] = useState(false);

    return (
        <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
            <Backdrop open={isLoading} style={{ zIndex: 99999 }}>
                <CircularProgress />
            </Backdrop>
            {children}
        </LoadingContext.Provider>
    );
}
